import Avatar from 'components/ui/Avatar';
import { useTranslation } from 'react-i18next';

const JobUser = job => {
  const { t } = useTranslation();

  const user = job.user || {};

  return (
    <div className="d-flex align-items-center mb-2">
      <Avatar
        size={32}
        name={user.name}
        email={user.email || 'unknow@youfy.com.br'}
        src={user.profile_image}
        className="user-avatar rounded-circle shadow-sm hover-ouline-primary"
      />

      <div className="ms-2 lh-sm">
        <small>{t('bots.jobs.card.columns.request_by')}</small> <br />
        <div className="text-truncate" title={user.name} style={{ width: 120 }}>
          <b>{user.name}</b>
        </div>
      </div>
    </div>
  );
};

export default JobUser;
